function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('p',[_vm._v("Boost your business by optimizing your digital channels. Find out which online campaigns work better by measuring the whole customer journey:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("From online ads & website visits")]),_vm._v(" "),_c('li',[_vm._v("Through phone calls")]),_vm._v(" "),_c('li',[_vm._v("To visitations and sales")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/home/sales-funnel/details","summary":"Understand Your Online Traffic"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }